import { render, staticRenderFns } from "./onlineSignature.vue?vue&type=template&id=4120ca3b&scoped=true"
import script from "./onlineSignature.vue?vue&type=script&lang=js"
export * from "./onlineSignature.vue?vue&type=script&lang=js"
import style0 from "./onlineSignature.vue?vue&type=style&index=0&id=4120ca3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4120ca3b",
  null
  
)

export default component.exports